<template>
  <news-article-card>
    <nuxt-link
      :to="linkToArticle"
      class="h-full relative flex flex-col justify-end p-4 md:p-8 no-underline text-mouse cursor-pointer overflow-hidden"
      :class="fullWidthOnMobile ? 'rounded-none md:rounded-lg' : 'rounded-lg'"
    >
      <strapi-image
        class="absolute top-0 left-0 w-full h-full z-0 bg-cover bg-center"
        :class="fullWidthOnMobile ? 'rounded-none md:rounded-lg' : 'rounded-lg'"
        :image="article.teaserImage || article.headerCoverImage"
        :alt="article.title"
        as-background
      />
      <div
        class="news-article__veil absolute top-0 left-0 w-full h-full z-1 pointer-events-none"
        :class="fullWidthOnMobile ? 'rounded-none md:rounded-lg' : 'rounded-lg'"
      ></div>

      <div
        class="absolute top-4 left-4 md:top-6 md:left-6 bg-depth-0 px-3 py-1 rounded-md font-bold text-mouse capitalize z-3"
      >
        {{ article.type }}
      </div>

      <p class="mb-0 text-xl font-bold uppercase relative z-2">
        <span class="text-rhino">{{ publishedAt }}</span>
        <template v-if="article.category !== 'None'">
          &nbsp;/&nbsp;
          <span class="font-bold text-mouse">{{ article.category }}</span>
        </template>
      </p>
      <h2 class="relative z-2 uppercase">{{ article.title }}</h2>
      <p class="w-full md:w-3/4 md:text-xl relative z-2">
        {{ article.teaserText }}
      </p>
      <div
        class="bg-brand text-onyx font-bold uppercase tracking-widest mt-3 px-8 py-3 rounded-md transition-colors w-fit relative z-2"
      >
        {{ $t('homePage/readMore') }}
      </div>
    </nuxt-link>
  </news-article-card>
</template>

<script setup lang="ts">
import type { StrapiArticle } from '~/apollo/types/types';
import {
  useArticleLink,
  useArticlePublishedDate,
} from './features/useArticleFeatures';

const props = defineProps<{
  article: StrapiArticle;
  fullWidthOnMobile?: boolean;
}>();
const { publishedAt } = useArticlePublishedDate(props.article);
const { linkToArticle } = useArticleLink(props.article);
</script>

<style scoped>
.news-article__veil {
  background: linear-gradient(
    to right,
    var(--color-depth-4),
    color-mix(in srgb, var(--color-depth-4) 80%, transparent) 60%,
    transparent 100%
  );
}
</style>
